import { PlusIcon, TrashIcon } from "@heroicons/react/24/outline";

import { Button } from "V2.0/common/button";
import { Input } from "V2.0/common/input";
import { Text } from "V2.0/common/text";
import {
  Fieldset,
  Legend,
  Field,
  ErrorMessage,
} from "V2.0/common/fieldset";

export default EvalRunConfigPersonaAttributes;

/**
 * Inline key/value rows rather than the Pipelines KeyValuePairs table: that one
 * edits each pair in its own dialog, which would open on top of the persona
 * dialog.
 */
function EvalRunConfigPersonaAttributes(props) {
  const { rows, rowErrors, error, onRowsChange } = props;

  const handleRowChange = (rowIdx, field, value) => {
    onRowsChange(
      rows.toSpliced(rowIdx, 1, { ...rows[rowIdx], [field]: value }),
    );
  };

  const handleAddRow = () => {
    onRowsChange([...rows, { key: "", value: "" }]);
  };

  const handleRemoveRow = (rowIdx) => {
    onRowsChange(rows.toSpliced(rowIdx, 1));
  };

  return (
    <Fieldset>
      <Legend>Attributes</Legend>
      <Text>
        Optional — this customer's values for the {"{placeholders}"} in the
        assistant's prompt, e.g. firstName or dueAmount. They replace the
        assistant's own attributes with the same name.
      </Text>

      <div
        data-slot="control"
        className="flex flex-col gap-y-3"
      >
        {rows.map((row, rowIdx) => (
          <Field key={rowIdx}>
            <div className="flex items-center gap-x-2">
              <Input
                aria-label="Attribute key"
                placeholder="firstName"
                value={row.key}
                onChange={(e) => handleRowChange(rowIdx, "key", e.target.value)}
                invalid={!!rowErrors?.[rowIdx]}
                className="flex-1"
              />
              <Input
                aria-label="Attribute value"
                placeholder="Priya"
                value={row.value}
                onChange={(e) =>
                  handleRowChange(rowIdx, "value", e.target.value)
                }
                invalid={!!rowErrors?.[rowIdx]}
                className="flex-[2]"
              />
              <Button
                plain
                aria-label="Remove attribute"
                onClick={() => handleRemoveRow(rowIdx)}
              >
                <TrashIcon />
              </Button>
            </div>
            {rowErrors?.[rowIdx] && (
              <ErrorMessage className="mt-1">{rowErrors[rowIdx]}</ErrorMessage>
            )}
          </Field>
        ))}

        {/* ErrorMessage is a Headless UI Description, which throws (or binds to
            the dialog's description) outside a Field. */}
        {error && (
          <Field>
            <ErrorMessage>{error}</ErrorMessage>
          </Field>
        )}

        <div>
          <Button
            plain
            onClick={handleAddRow}
          >
            <PlusIcon /> Attribute
          </Button>
        </div>
      </div>
    </Fieldset>
  );
}
